'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAccessTime = function DeviceAccessTime(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
  );
};
DeviceAccessTime = (0, _pure2.default)(DeviceAccessTime);
DeviceAccessTime.displayName = 'DeviceAccessTime';
DeviceAccessTime.muiName = 'SvgIcon';

exports.default = DeviceAccessTime;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/device/access-time.js
 ** module id = 814
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/device/access-time.js
 ** module id = 814
 ** module chunks = 1
 **/